var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "footer-consent-tab"
  }, [_c('div', {
    staticClass: "pa-5 pb-12"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('footer_consent_footer_section')))]), _vm.isAdmin ? _c('v-switch', {
    staticClass: "mt-4 d-inline-flex",
    attrs: {
      "label": _vm.$t('footer_hide_label'),
      "hide-details": ""
    },
    model: {
      value: _vm.footerHide,
      callback: function callback($$v) {
        _vm.footerHide = $$v;
      },
      expression: "footerHide"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "sub-label mt-4"
  }, [_vm._v(_vm._s(_vm.$t('footer_body_label')))]), _c('text-edit', {
    key: _vm.footerBodyEditorKey,
    staticClass: "footer-body-edit",
    class: {
      'disabled-input': _vm.footerHide || !_vm.isAdmin
    },
    attrs: {
      "content": _vm.footerBody,
      "is-translation-edit": true,
      "disable-rich-text": _vm.footerHide || !_vm.isAdmin,
      "disable-variables": true,
      "placeholder": _vm.$t('scanresult_powered_by_scantrust')
    },
    on: {
      "update:content": _vm.setFooterBody
    }
  }), _c('div', {
    staticClass: "sub-label mt-4"
  }, [_vm._v(_vm._s(_vm.$t('footer_background_label')))]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "auto",
      "disabled": _vm.footerHide,
      "rules": _vm.urlRules,
      "placeholder": "https://…/footer-bg.png"
    },
    on: {
      "focus": function focus($event) {
        _vm.urlBeforeEdit = _vm.savedUrl('footer', 'background');
      },
      "change": function change($event) {
        return _vm.clearUrlLanguageCopies('footer', 'background');
      }
    },
    model: {
      value: _vm.footerBackground,
      callback: function callback($$v) {
        _vm.footerBackground = $$v;
      },
      expression: "footerBackground"
    }
  }), _vm.isAllowed('gallery_view') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-2",
          attrs: {
            "icon": "",
            "color": "primary",
            "disabled": _vm.footerHide
          },
          on: {
            "click": function click($event) {
              _vm.displaySTGalleryDialog = true;
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-image-outline")])], 1)];
      }
    }], null, false, 3915667467)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('translations_select_image')))])]) : _vm._e()], 1), _c('div', {
    staticClass: "sub-label mt-7"
  }, [_vm._v(_vm._s(_vm.$t('footer_privacy_url_label')))]), _c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "auto",
      "rules": _vm.urlRules,
      "placeholder": "https://www.scantrust.com/privacy-policy"
    },
    on: {
      "focus": function focus($event) {
        _vm.urlBeforeEdit = _vm.savedUrl('footer', 'privacy');
      },
      "change": function change($event) {
        return _vm.clearUrlLanguageCopies('footer', 'privacy');
      }
    },
    model: {
      value: _vm.footerPrivacyUrl,
      callback: function callback($$v) {
        _vm.footerPrivacyUrl = $$v;
      },
      expression: "footerPrivacyUrl"
    }
  }), _c('div', {
    staticClass: "sub-label mt-7"
  }, [_vm._v(_vm._s(_vm.$t('footer_privacy_button_label')))]), _c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "",
      "placeholder": "Privacy Policy"
    },
    model: {
      value: _vm.footerPrivacyButton,
      callback: function callback($$v) {
        _vm.footerPrivacyButton = $$v;
      },
      expression: "footerPrivacyButton"
    }
  }), _c('div', {
    staticClass: "sub-label mt-7"
  }, [_vm._v(_vm._s(_vm.$t('footer_cookie_button_label')))]), _c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "",
      "disabled": _vm.footerHide,
      "placeholder": "Cookie Policy"
    },
    model: {
      value: _vm.footerCookieButton,
      callback: function callback($$v) {
        _vm.footerCookieButton = $$v;
      },
      expression: "footerCookieButton"
    }
  }), _c('div', {
    staticClass: "label font-weight-bold section-header-gap"
  }, [_vm._v(_vm._s(_vm.$t('footer_consent_cookie_section')))]), _c('div', {
    staticClass: "sub-label mt-4"
  }, [_vm._v(_vm._s(_vm.$t('cookie_message_label')))]), _c('v-textarea', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "",
      "rows": "1",
      "auto-grow": "",
      "placeholder": "We use necessary cookies…"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.cookieMessage,
      callback: function callback($$v) {
        _vm.cookieMessage = $$v;
      },
      expression: "cookieMessage"
    }
  }), _c('div', {
    staticClass: "sub-label mt-6"
  }, [_vm._v(_vm._s(_vm.$t('cookie_accept_label')))]), _c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "",
      "placeholder": "Accept cookies"
    },
    model: {
      value: _vm.cookieAccept,
      callback: function callback($$v) {
        _vm.cookieAccept = $$v;
      },
      expression: "cookieAccept"
    }
  }), _c('div', {
    staticClass: "sub-label mt-7"
  }, [_vm._v(_vm._s(_vm.$t('cookie_decline_label')))]), _c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "",
      "placeholder": "Decline"
    },
    model: {
      value: _vm.cookieDecline,
      callback: function callback($$v) {
        _vm.cookieDecline = $$v;
      },
      expression: "cookieDecline"
    }
  }), _c('div', {
    staticClass: "sub-label mt-7"
  }, [_vm._v(_vm._s(_vm.$t('cookie_policy_label')))]), _c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "",
      "placeholder": "Cookie Policy"
    },
    model: {
      value: _vm.cookiePolicy,
      callback: function callback($$v) {
        _vm.cookiePolicy = $$v;
      },
      expression: "cookiePolicy"
    }
  }), _c('div', {
    staticClass: "sub-label mt-7"
  }, [_vm._v(_vm._s(_vm.$t('cookie_link_label')))]), _c('v-text-field', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "auto",
      "rules": _vm.urlRules,
      "placeholder": "https://www.scantrust.com/privacy-policy/"
    },
    on: {
      "focus": function focus($event) {
        _vm.urlBeforeEdit = _vm.savedUrl('cookie', 'link');
      },
      "change": function change($event) {
        return _vm.clearUrlLanguageCopies('cookie', 'link');
      }
    },
    model: {
      value: _vm.cookieLink,
      callback: function callback($$v) {
        _vm.cookieLink = $$v;
      },
      expression: "cookieLink"
    }
  })], 1), _c('select-image-dialog', {
    attrs: {
      "display-select-image-dialog": _vm.displaySTGalleryDialog,
      "app-tags": ['stc-editor-image'],
      "isAllowedEdit": _vm.isAllowed('gallery_edit')
    },
    on: {
      "update:displaySelectImageDialog": function updateDisplaySelectImageDialog($event) {
        _vm.displaySTGalleryDialog = false;
      },
      "gallery-selected": _vm.handleSTGallerySelected
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }